<template>
  <p class="logo-text">
    <span>For good and</span>
    <span>efficient printing</span>
  </p>
</template>

<script>
export default {
  name: "LogoText"
};
</script>

<style lang="scss">
.logo-text {
  margin: 0;
  line-height: 1.25;
  color: $black-color;

  span {
    display: block;
  }
}
</style>